import React, { useState } from "react";
import {useDispatch} from 'react-redux';
import { TextField, Paper, Avatar, IconButton } from "@material-ui/core";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import AddBoxIcon from "@material-ui/icons/AddBox";
import { green } from "@material-ui/core/colors";
import { ObservacionItem } from "./ObservacionItem";
import { observacionesInsertStart } from "../../actions/observaciones";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(1),
      width: theme.spacing(16),
      height: theme.spacing(16),
    },
  },
  container: {
    width: "80vw",
  },
  texto: {
    padding: 2,
    margin: 3,
    width: "60vw",
  },
  iconoAdd: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    color: "#fff",
    backgroundColor: green[500],
    marginTop: 35,
    marginRight: 35,
  },
  divContenedor: {
    display: "flex",
    justifyContent: "space-between",
  },
  contenedorObservaciones:{
    maxHeight:300,
    overflow:'auto'
  },
  gridNone:{
    pointerEvents: 'none',
    opacity: 0.4,
  }
}));

export const Observaciones = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [observacion, setObservacion] = useState("");
  const handleInputChange = (e) => {
    if (e.target.value === "") {
      setErrorValidacion(true);
    } else {
      setErrorValidacion(false);
    }
    setObservacion(e.target.value);
  };
  const handleAddClick = (e) => {
    e.preventDefault();
    let error = false;
    setErrorValidacion(false);
    if (observacion.length === 0) {
      error = true;
      setErrorValidacion(true);
    }
    if (!error) {
      dispatch(observacionesInsertStart(observacion));
      setObservacion('');
    }
  };
  const [errorValidacion, setErrorValidacion] = useState(false);
  const { cargada, items } = useSelector(
    (state) => state.observacionesAfiliacion
  );

  return (
    <div className={props.idForm==='formConsulta'?classes.gridNone:null}>
      <div className={classes.contenedorObservaciones}>
        {cargada &&
          items.length > 0 &&
          items.map((item) => (
            <ObservacionItem key={item.idItem} item={item} />
          ))}
      </div>
      <div className={classes.root}>
        {" "}
        <Paper className={classes.container} elevation={3}>
          <div className={classes.divContenedor}>
            <TextField
              className={classes.texto}
              placeholder="Ingrese una observacion"
              multiline
              error={errorValidacion}
              helperText={errorValidacion && "Ingrese Observacion"}
              rows={4}
              onChange={handleInputChange}
              rowsMax={8}
              value={observacion}
              variant="outlined"
            />
            <IconButton onClick={handleAddClick} aria-label="add">
              <Avatar className={classes.iconoAdd}>
                <AddBoxIcon />
              </Avatar>
            </IconButton>
          </div>
        </Paper>
      </div>
    </div>
  );
};
